<template>
  <div id="iPrint">
    <h2>Сопроводительный паспорт перевозки отходов</h2>
    <el-row :gutter="10">
      Регистрационный номер (порядковый номер паспорта в журнале регистрации
      сопроводительных паспортов перевозки отходов производства)
      <el-input-number v-model="form.number"></el-input-number>
    </el-row>
    <br />
    <el-row :gutter="10">
      Собственник перевозимых отходов производства:
      <el-radio-group v-model="form.ca1" class="ml-4">
        <el-radio label="Контрагент"></el-radio>
        <el-radio label="Ручной ввод"></el-radio>
      </el-radio-group>
    </el-row>
    <el-row :gutter="10" v-if="form.ca1 == 'Контрагент'">
      <el-select
        style="width: 100%"
        clearable
        @change="selectContractor(form)"
        v-model="form.contractor1"
        filterable
        placeholder="Собственник"
      >
        <el-option
          v-for="item in contractorList1.content"
          :key="item.contractorId"
          :label="item.nameManual"
          :value="item.contractorId"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-row :gutter="10" v-if="form.ca1 == 'Ручной ввод'">
      <el-input v-model="form.contractor1r"></el-input>
    </el-row>
    <br />
    <el-row :gutter="10">
      Получатель перевозимых отходов производства:
      <el-radio-group v-model="form.ca2" class="ml-4">
        <el-radio label="Контрагент"></el-radio>
        <el-radio label="Ручной ввод"></el-radio>
      </el-radio-group>
    </el-row>
    <el-row :gutter="10" v-if="form.ca2 == 'Контрагент'">
      <el-select
        style="width: 100%"
        clearable
        @change="selectContractor(form)"
        v-model="form.contractor2"
        filterable
        placeholder="Получатель"
      >
        <el-option
          v-for="item in contractorList1.content"
          :key="item.contractorId"
          :label="item.nameManual"
          :value="item.contractorId"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-row :gutter="10" v-if="form.ca2 == 'Ручной ввод'">
      <el-input v-model="form.contractor2r"></el-input>
    </el-row>
    <br />
    <el-row :gutter="10">
      Перевозчик отходов производства:
      <el-radio-group v-model="form.ca3" class="ml-4">
        <el-radio label="Контрагент"></el-radio>
        <el-radio label="Ручной ввод"></el-radio>
      </el-radio-group>
    </el-row>
    <el-row :gutter="10" v-if="form.ca3 == 'Контрагент'">
      <el-select
        style="width: 100%"
        clearable
        @change="selectContractor(form)"
        v-model="form.contractor3"
        filterable
        placeholder="Перевозчик"
      >
        <el-option
          v-for="item in contractorList1.content"
          :key="item.contractorId"
          :label="item.nameManual"
          :value="item.contractorId"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-row :gutter="10" v-if="form.ca3 == 'Ручной ввод'">
      <el-input v-model="form.contractor3r"></el-input>
    </el-row>

    <br />
    <el-row :gutter="10">
      Дата перевозки отходов производства: {{ transportDate }}
    </el-row>
    <br />
    <el-row>
      Транспортное средство - марка и регистрационный знак:
      <el-input v-model="form.vehicle"></el-input>
    </el-row>
    <br />
    <el-row>
      Фамилия, собственное имя, отчество (если таковое имеется) водителя:
      <el-input v-model="form.full_name"></el-input>
    </el-row>
    <br />

    <el-row v-for="item in waste" v-bind:key="item.ss01DictionaryId">
      <el-row>
        {{ item.wasteCode }}-{{ item.wasteName }}
        <br />
        Тара (упаковка) - наименование:
        <el-input v-model="item.tara_name"></el-input>
      </el-row>
      <br />
      <el-row>
        Тара (упаковка) - общий вес, тонн:
        <el-input v-model="item.tara_vight"></el-input>
      </el-row>
      <br />
    </el-row>

    <br />
    <el-row>
      Вес транспорта (брутто), тонн:
      <el-input
        :value="form.vehicle_vight"
        @input="form.vehicle_vight = numberText($event)"
        inputmode="decimal"
        placeholder="Например, 12.5"
      ></el-input>
    </el-row>
    <br />
    <el-row>
      Номер аварийной карточки:
      <el-input v-model="form.number_card"></el-input>
    </el-row>
    <br />
    <el-row :gutter="10">
      Собственник отходов производства:
      <el-radio-group v-model="form.ow" class="ml-4">
        <el-radio label="Ответственное лицо"></el-radio>
        <el-radio label="Ручной ввод"></el-radio>
      </el-radio-group>
    </el-row>
    <el-row :gutter="10" v-if="form.ow == 'Ответственное лицо'">
      <el-select
        clearable
        class="searchPole"
        v-model="form.owner"
        value-key="id"
        placeholder="Собственник отходов производства:"
      >
        <el-option
          v-for="item in listResponsiblePersonForSelect"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-row :gutter="10" v-if="form.ow == 'Ручной ввод'">
      <el-input v-model="form.ownerr"></el-input>
    </el-row>
    <br />

    <el-row :gutter="10">
      Перевозчик отходов произвдства:
      <el-radio-group v-model="form.tr" class="ml-4">
        <el-radio label="Ответственное лицо"></el-radio>
        <el-radio label="Ручной ввод"></el-radio>
      </el-radio-group>
    </el-row>
    <el-row :gutter="10" v-if="form.tr == 'Ответственное лицо'">
      <el-select
        clearable
        class="searchPole"
        v-model="form.transfer"
        value-key="id"
        placeholder="Перевозчик отходов произвдства:"
      >
        <el-option
          v-for="item in listResponsiblePersonForSelect"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-row :gutter="10" v-if="form.tr == 'Ручной ввод'">
      <el-input v-model="form.transferr"></el-input>
    </el-row>

    <el-button type="primary" @click="addPasportToTable"
      >Сохранить паспорт</el-button
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import VueHtmlToPaper from "vue-html-to-paper";
import { AXIOS } from "@/AXIOS/http-common";
import notification from "@/mixins/notification";

export default {
  props: ["action", "waste"],
  name: "disposalPasportForm",
  mixins: [notification],
  data() {
    return {
      // Редактируемая копия паспорта: prop action - только номер паспорта от родителя
      form: {},
      fileTypes: [
        {
          value: ".pdf",
          label: ".pdf",
        },
        {
          value: ".xls",
          label: ".xls",
        },
      ],
      contractor: "",
      data: {},
      const_options: {
        name: "_blank",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
        ],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      },
    };
  },

  computed: {
    ...mapGetters({
      contractorList1: "GETLISTCONTRACTORS",
      listResponsiblePersonForSelect: "GETLISTRESPONSIBLEPERSONFORSEARCH",
      NumberPassport: "GETDATASTORED",
    }),
    // Дата приходит таймстампом или строкой yyyy-MM-dd - показываем дд.мм.гггг
    transportDate() {
      if (!this.form.date) return "";
      const date = new Date(this.form.date);
      return isNaN(date) ? this.form.date : date.toLocaleDateString("ru-RU");
    },
  },

  methods: {
    // Только цифры и одна точка: запятая заменяется на точку, остальное отбрасывается
    numberText(value) {
      const text = String(value || "")
        .replace(",", ".")
        .replace(/[^\d.]/g, "");
      const dot = text.indexOf(".");
      return dot < 0
        ? text
        : text.slice(0, dot + 1) + text.slice(dot + 1).replace(/\./g, "");
    },

    addPasportToTable() {
      this.$store.dispatch("updatePassport", this.form).then(() => {
        this.notification("Успешно", "Паспорт изменен", "success");
        this.$store.dispatch("setShowModal", null);
      });
    },
    Print() {
      Vue.use(VueHtmlToPaper, this.const_options);
      Vue.use(VueHtmlToPaper);
      this.$htmlToPaper("iPrint");
    },
    getListResponsiblePersonForSelect() {
      let units = [];
      this.$store.dispatch("getListResponsiblePersonForSelect", units);
    },

    selectContractor(as) {
      console.log(as);
      /*this.data.
      this.$store.dispatch("searchContractorsByName", this.contractor);*/
    },

    addContractor() {
      this.$router.push("contractors/add");
    },
  },

  async mounted() {
    console.log(this);
    await AXIOS.get(
      "report/get/passportValues?passportID=" + this.action.num
    ).then((response) => {
      const data = response.data;
      // Объект собирается целиком до присваивания - тогда все поля реактивные и в них можно вводить
      this.form = {
        ...data,
        vehicle: data.vehicle || "",
        full_name: data.full_name || "",
        vehicle_vight: data.vehicle_vight || "",
        number_card: data.number_card || "",
        ca1: data.contractor1r == null ? "Контрагент" : "Ручной ввод",
        ca2: data.contractor2r == null ? "Контрагент" : "Ручной ввод",
        ca3: data.contractor3r == null ? "Контрагент" : "Ручной ввод",
        tr: data.transferr == null ? "Ответственное лицо" : "Ручной ввод",
        ow: data.ownerr == null ? "Ответственное лицо" : "Ручной ввод",
      };
    });
    console.log(this);
    //this.user_id= Cookies.get('userId');
    //this.action.contractor1r = 1;
    this.data.page = 0;
    this.data.size = 350;
    await this.$store.dispatch("getAllContractors", this.data);

    this.getListResponsiblePersonForSelect(-1);
    /*console.log("pass");
    console.log(this);*/
  },
};
</script>

<style scoped></style>
